import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import libraryProjectsAndListsQuery from '../../queries/libraryProjectsAndLists';
import { Project, SuggestionsList } from '../../types/api-copied';
import { UtilMixin } from '../../UtilMixin';
import Pager from '../shared/pager.vue';
import ProjectEditor from './projectEditor.vue';
import SectionTitle from '../shared/sectionTitle.vue';
import { ViewerContext } from '../..//types/viewer_context';

@Component({ components: { ProjectEditor, Pager, SectionTitle } })
export default class ProjectsGrid extends Mixins(UtilMixin) {
  @Getter public viewerContext!: ViewerContext;

  public readonly query = libraryProjectsAndListsQuery;

  public get queryVariables() {
    return {
      institutionId: this.viewerContext.institutionId,
    };
  }

  public getStateLabelForProject(
    project: Project,
    suggestionsList: SuggestionsList
  ) {
    let text: any;
    switch (project.state) {
      case 'CREATED':
        text = this.$t('common.project.state.created');
        break;
      case 'CANCELED':
        text = this.$t('common.project.state.canceled');
        break;
      case 'CLOSED':
        text = this.$t('common.project.state.closed');
        break;
      case 'IN_PROGRESS':
        switch (suggestionsList.state) {
          case 'IN_PROGRESS':
            text = this.$t('common.project.state.in_progress');
            break;
          case 'CHANGES_REQUESTED':
            text = this.$t('common.project.state.changes_requested');
            break;
          case 'SUBMITTED':
            text = this.$t('common.project.state.submitted');
            break;
        }
        break;
    }
    return text;
  }

  public projectLink(project: any): any {
    if (
      project == null ||
      !(project.state === 'IN_PROGRESS' || project.state === 'CREATED')
    ) {
      throw new Error('Can create a link for project');
    }

    if (project.state === 'IN_PROGRESS') {
      return {
        name: 'suggestionsList',
        params: { suggestionsListId: project.suggestionsListId },
      };
    } else {
      return { name: 'project', params: { projectId: project.id } };
    }
  }

  public projectLinkText(project: any): any {
    if (
      project == null ||
      !(project.state === 'IN_PROGRESS' || project.state === 'CREATED')
    ) {
      throw new Error('Can create a link for project');
    }

    if (project.state === 'IN_PROGRESS') {
      return this.$t('components.library.projects_grid.review_suggestions');
    } else {
      return this.$t('components.library.projects_grid.details');
    }
  }
}
